import { IIndexable } from '../interfaces';

export const TABLER_CATEGORIES = ['Devices', 'Design', 'System', 'Vehicles', 'Text', 'Map', 'Symbols', 'Photography', 'Food', 'Arrows', 'Media', 'Sport', 'Health', 'E-commerce', 'Document', 'Numbers', 'Math', 'Brand', 'Nature', 'Buildings', 'Charts', 'Shapes', 'Weather', 'Database', 'Currencies', 'Gender', 'Gestures', 'Letters', 'Communication', 'Mood', 'Zodiac'];

export const getIconsData = () : IIndexable => {
    const $box = document.getElementById('icons-data');
    if(!$box || !$box.textContent) return {};

    let data:IIndexable = {};

    try{
        data = JSON.parse($box.textContent) as IIndexable;
    }
    catch (ex){}

    return data;
};